"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOutsmartlyScriptData = getOutsmartlyScriptData;

var _getRehydrationData = require("./getRehydrationData.js");

function getOutsmartlyScriptData() {
  var json = (0, _getRehydrationData.getRehydrationData)();

  if (!json) {
    return null;
  }

  return JSON.parse(json);
}